import { useEffect as A } from "react";
import { DateTime as B } from "luxon";
import { useEnvironment as K } from "../../../../features/common/hooks/environment/useEnvironment.js";
import { useMapsApi as W } from "../../../../features/google/hooks/useMapsApi.js";
import { ServiceType as u, ServiceMapTypes as I } from "../../../../../common/shared/serviceType.js";
import { useBookingServiceAction as H } from "../components/BookingForm/hooks/useBookingServiceAction.js";
import { useAddressServiceAction as z } from "../components/OrderingForm/hooks/useAddressServiceAction.js";
import { useBooking as Q } from "../components/BookingForm/context.js";
import { useOrdering as $ } from "../components/OrderingForm/context.js";
import { useServiceSessionFromForm as G } from "./backend/useServiceSession.js";
import { LANDING_QUERY_PARAMS as s } from "../shared/landing-query-params.js";
import { useAddressValidation as X } from "./backend/useAddressValidation.js";
import j from "./customization/useCustomization.js";
import q from "./useOrderLater.js";
import { nearestQuarterHour as J } from "../../../../utils.js";
function ue() {
  const p = $(), g = Q(), _ = new URL(window.location.href), r = new URLSearchParams(_.search), { mapApiKey: h } = K(), {
    isApiReady: y,
    getPlaceDetails: k
  } = W(h), { configuration: c, getScopeLocations: E } = j(), { getRestaurantUrl: O } = G(), { mutateAsync: C } = X(), { proceed: w } = z(), {
    proceed: F
  } = H();
  A(() => {
    p.setIsActive(r.get(s.POPUP) === "on");
  }, []);
  const M = {
    address: "",
    latitude: 0,
    longitude: 0
  }, U = async (t) => {
    const { restaurants: o } = await C({
      serviceType: t,
      ...M
    });
    return o;
  }, v = async (t, o, d, n) => {
    let a = await O(
      { place: null },
      t,
      o,
      d
    );
    a && (n && (a = `${a}&table_id=${n}`), window.location.href = a);
  }, { orderLater: b } = q(), S = (t) => !!I[t], x = async () => {
    if (c != null && c.settings.popup.addressMandatory)
      return;
    const t = E(u.TAKEAWAY), o = E(u.DELIVERY);
    t.length === 1 && o.length === 0 && await w(u.TAKEAWAY, {
      place: null
    });
  }, V = async () => {
    const t = r.get(s.MODE), o = r.get(s.SERVICE), d = r.get(s.LOCATION_ID), n = r.get(s.NOW), a = r.get(s.TABLE_ID);
    if (t === null && o && S(o)) {
      const l = I[o], m = await U(
        l
      );
      if (!m.length)
        return;
      let e = null;
      if (d && (e = m.find((f) => f.id === parseInt(d, 10)) ?? null), !e) return;
      if (l === u.DINE_IN) {
        v(e, l, !0, a);
        return;
      }
      if (n && e.is_now_available)
        v(e, l, !!n, a);
      else {
        const f = await b(
          [e],
          u.TAKEAWAY,
          null
        );
        p.setIsActive(!0), p.setStep({
          name: "time-selector",
          data: f
        });
      }
    }
  };
  async function Y() {
    var P, L, R, D;
    const t = r.get(s.MODE), o = r.get(s.SERVICE), d = r.get(s.PLACE_ID), n = r.get(s.ADDRESS_EXTRA), a = r.get(s.PEOPLE), l = r.get(s.TIMESTAMP), m = { ...p.form }, e = { ...g.form };
    if (d) {
      const i = await k(d), N = {
        formattedAddress: i.formatted_address ?? "",
        addressComponents: i.address_components ?? [],
        lat: ((L = (P = i.geometry) == null ? void 0 : P.location) == null ? void 0 : L.lat()) ?? 0,
        long: ((D = (R = i.geometry) == null ? void 0 : R.location) == null ? void 0 : D.lng()) ?? 0,
        placeId: i.place_id ?? ""
      };
      m.place = N, e.place = N;
    }
    n && (m.addressInfo = n), p.setForm(m);
    const f = parseInt(a ?? "", 10);
    Number.isNaN(f) || (e.people = f);
    const T = parseInt(l ?? "", 10);
    if (!Number.isNaN(T)) {
      const i = B.fromSeconds(T).toUTC();
      e.day = i.startOf("day").toUnixInteger(), e.hour = J(i).toFormat("HH:mm");
    }
    g.setForm(e), o && S(o) && t === "ordering" && await w(I[o], m), e.day && e.hour && e.place && await F(e), t === "ordering" && p.setIsActive(!0), t === "booking" && g.setIsActive(!0);
  }
  A(() => {
    (async () => c && (await x(), await V()))();
  }, [c]), A(() => {
    !y || !c || Y();
  }, [y, c]);
}
export {
  ue as default
};
//# sourceMappingURL=useLandingParameters.js.map
